export default import.meta.ROLLDOWN_FILE_URL_xj2Xv_mUSfUMgcujKcDLEQ